import React from "react";
import { useDispatch, } from "react-redux";
import { useTypedSelector } from "../../store/models/root.interface";
import { removeNotification } from "../../store/actions/notifications.action";
import { Bell, Info, Frown } from "react-feather";

const Notifications: React.FC = () => {
    const dispatch = useDispatch();
    const notifications = useTypedSelector(
        state => state.notifications.notifications
    );

    function closeNotification(id: number) {
        dispatch(removeNotification(id));
    }

    const notificationList = notifications.map((notification) => {
        setTimeout(function () {
            dispatch(removeNotification(notification.id));
        }, 10000);

        return (
            <div
                className={`toast ${notification.status == "error" ? "error" : ""}`}
                key={`notification_${notification.id}`}
            >
                <div className="toast-header">
                    <strong className="mr-auto">
                        {notification.status == "error" ? <Frown /> : <Bell />}
            &nbsp; {notification.title}
                    </strong>
                    <small>
                        {notification.date.toLocaleTimeString(navigator.language, {
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </small>
                    <button
                        type="button"
                        className="ml-2 mb-1 close"
                        data-dismiss="toast"
                        aria-label="Close"
                        onClick={() => closeNotification(notification.id)}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">
                    <p>Please contact the administrator</p>
                    <p>
                        <small>Details: {notification.text}</small>
                    </p>
                </div>
            </div>
        );
    });

    return <div className="toast-wrapper">{notificationList}</div>;
};

export default Notifications;
